// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
html {
  scroll-behavior: smooth;
}

body {
  background-color: #ffffff;
  color: #111827;
  font-family: 'Inter', sans-serif;
  margin: 0;
  padding: 0;
}

.dark-section {
  background-color: #111827;
  color: #ffffff;
}

/* Links */
a {
  color: inherit;
  text-decoration: none;
}

/* Headings */
h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  color: inherit;
  margin-bottom: 12px;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

/* Paragraphs */
p {
  font-size: 1.2rem;
  line-height: 1.6;
  color: inherit;
  margin-bottom: 16px;
}

/* Span */
span {
  font-size: inherit;
  color: #40f2cb;
}

/* Buttons */
.btn {
  background-color: #f4f4f4;
  display: inline-block;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  transition: all 0.3s ease;
  text-align: center;
  cursor: pointer;
  border: 2px solid #111827;
  box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.2);
  position: relative;
}

.btn:hover {
  transform: scale(1.04);
  box-shadow: none;
}

.btn-primary {
  background-color: #40f2cb;
  color: #111827;
}

.btn-primary:hover {
  background-color: #2bc3a5;
}

.btn-secondary {
  background-color: #cccccc;
  color: #000000;
}

.btn-secondary:hover {
  background-color: #8e8e8e;
}

.btn-tertiary {
  background-color: #fd4f3f;
  color: #111827;
}

.btn-tertiary:hover {
  background-color: #e65a50;
}

/* Cards */
.card {
  background-color: #ffffff;
  color: #111827;
  border-radius: 12px;
  border: 2px solid #111827;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease-in-out;
}

.card h3 {
  margin: 0;
}

.card-header {
  font-weight: 700;
  font-size: 1rem;
}

.dark-card {
  background-color: #111827 !important;
  color: #ffffff !important;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(123, 123, 123, 0.2);
  transition: transform 0.2s ease-in-out;
}

/* Forms */
input, textarea {
  width: 100%;
  padding: 12px;
  margin: 8px 0;
  background-color: inherit;
  border: 2px solid #111827;
  border-radius: 6px;
  color: inherit;
  outline: none;
  transition: border 0.3s;
  box-sizing: border-box;
}

input:focus, textarea:focus {
  border-color: #40f2cb;
}

/* Checkboxes */
.checkbox-container {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-container input[type="checkbox"] {
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #111827;
  border-radius: 4px;
  background-color: inherit;
  position: relative;
  transition: all 0.3s ease;
}

.checkbox-container input[type="checkbox"]:checked {
  background-color: #40f2cb;
  border-color: #40f2cb;
}

.checkbox-container input[type="checkbox"]:checked::after {
  content: '\\2714';
  font-size: 14px;
  font-weight: bold;
  color: #111827;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Dropdown Selects */
select {
  width: 100%;
  padding: 12px;
  background-color: inherit;
  border: 2px solid #111827;
  border-radius: 6px;
  color: inherit;
  appearance: none;
  cursor: pointer;
  transition: border 0.3s;
}

select:focus {
  border-color: #40f2cb;
}  

.resources {
  max-width: 850px;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/assets/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gCAAgC;EAChC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* Global Styles */\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: #ffffff;\n  color: #111827;\n  font-family: 'Inter', sans-serif;\n  margin: 0;\n  padding: 0;\n}\n\n.dark-section {\n  background-color: #111827;\n  color: #ffffff;\n}\n\n/* Links */\na {\n  color: inherit;\n  text-decoration: none;\n}\n\n/* Headings */\nh1, h2, h3, h4, h5, h6 {\n  font-weight: 700;\n  color: inherit;\n  margin-bottom: 12px;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh4 {\n  font-size: 1.5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\n/* Paragraphs */\np {\n  font-size: 1.2rem;\n  line-height: 1.6;\n  color: inherit;\n  margin-bottom: 16px;\n}\n\n/* Span */\nspan {\n  font-size: inherit;\n  color: #40f2cb;\n}\n\n/* Buttons */\n.btn {\n  background-color: #f4f4f4;\n  display: inline-block;\n  padding: 12px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 4px;\n  transition: all 0.3s ease;\n  text-align: center;\n  cursor: pointer;\n  border: 2px solid #111827;\n  box-shadow: 0 4px 4px 4px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n.btn:hover {\n  transform: scale(1.04);\n  box-shadow: none;\n}\n\n.btn-primary {\n  background-color: #40f2cb;\n  color: #111827;\n}\n\n.btn-primary:hover {\n  background-color: #2bc3a5;\n}\n\n.btn-secondary {\n  background-color: #cccccc;\n  color: #000000;\n}\n\n.btn-secondary:hover {\n  background-color: #8e8e8e;\n}\n\n.btn-tertiary {\n  background-color: #fd4f3f;\n  color: #111827;\n}\n\n.btn-tertiary:hover {\n  background-color: #e65a50;\n}\n\n/* Cards */\n.card {\n  background-color: #ffffff;\n  color: #111827;\n  border-radius: 12px;\n  border: 2px solid #111827;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s ease-in-out;\n}\n\n.card h3 {\n  margin: 0;\n}\n\n.card-header {\n  font-weight: 700;\n  font-size: 1rem;\n}\n\n.dark-card {\n  background-color: #111827 !important;\n  color: #ffffff !important;\n  padding: 24px;\n  box-shadow: 0 4px 12px rgba(123, 123, 123, 0.2);\n  transition: transform 0.2s ease-in-out;\n}\n\n/* Forms */\ninput, textarea {\n  width: 100%;\n  padding: 12px;\n  margin: 8px 0;\n  background-color: inherit;\n  border: 2px solid #111827;\n  border-radius: 6px;\n  color: inherit;\n  outline: none;\n  transition: border 0.3s;\n  box-sizing: border-box;\n}\n\ninput:focus, textarea:focus {\n  border-color: #40f2cb;\n}\n\n/* Checkboxes */\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.checkbox-container input[type=\"checkbox\"] {\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  border: 2px solid #111827;\n  border-radius: 4px;\n  background-color: inherit;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.checkbox-container input[type=\"checkbox\"]:checked {\n  background-color: #40f2cb;\n  border-color: #40f2cb;\n}\n\n.checkbox-container input[type=\"checkbox\"]:checked::after {\n  content: '\\2714';\n  font-size: 14px;\n  font-weight: bold;\n  color: #111827;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* Dropdown Selects */\nselect {\n  width: 100%;\n  padding: 12px;\n  background-color: inherit;\n  border: 2px solid #111827;\n  border-radius: 6px;\n  color: inherit;\n  appearance: none;\n  cursor: pointer;\n  transition: border 0.3s;\n}\n\nselect:focus {\n  border-color: #40f2cb;\n}  \n\n.resources {\n  max-width: 850px;\n  margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
